import type { JanusCallRefs, JanusCallSetters } from './sessionRefs';
import { logJanus } from './utils';
import { acquireBrowserDefaultMicStream } from './webDevices';

export async function refreshLocalStreamForReconnect(
  r: JanusCallRefs,
  set: JanusCallSetters,
  bindMicTrackLifecycle: (track: MediaStreamTrack) => void
): Promise<boolean> {
  try {
    r.localStreamRef.current?.getTracks().forEach((tr) => tr.stop());

    const stream = await acquireBrowserDefaultMicStream();

    const [track] = stream.getAudioTracks();
    if (!track) {
      stream.getTracks().forEach((tr) => tr.stop());
      return false;
    }

    bindMicTrackLifecycle(track);
    track.enabled = !r.isMutedRef.current;
    r.localStreamRef.current = stream;
    set.setLocalStream(stream);
    r.micDisconnectHandledRef.current = false;
    r.pendingLocalStreamRefreshRef.current = false;
    logJanus('RECONNECT', 'refreshed local mic stream');
    return true;
  } catch (err) {
    logJanus('RECONNECT', 'refresh local stream failed', err);
    if (
      !r.networkDropPendingRef.current &&
      (r.isJoinedRef.current || r.callStatusRef.current === 'oncall') &&
      !r.micDisconnectHandledRef.current
    ) {
      r.micDisconnectHandledRef.current = true;
      r.onAudioHardwareLostRef.current?.({ target: 'mic', reason: 'not_found' });
    }
    return false;
  }
}
